export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 via-white to-gray-50">
        <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: `linear-gradient(#2C5F5D 1px, transparent 1px), linear-gradient(90deg, #2C5F5D 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      <div className="relative w-full max-w-[1400px] mx-auto px-8 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="space-y-8">
          <div className="inline-block">
            <span className="text-xs md:text-sm font-medium text-primary bg-white border border-primary/20 px-3 md:px-4 py-1.5 md:py-2 rounded-full whitespace-nowrap">
              中小EC向け 業務設計×自動化コンサル
            </span>
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-gray-900 leading-tight">
            EC運営を、<br />1日5分に。
          </h1>
          
          <p className="text-base md:text-xl lg:text-2xl text-gray-600 leading-relaxed">
            仕入れ・利益計算・出品データ・在庫同期を<br />
            <strong className="text-gray-800">"回る仕組み"</strong>にまとめます。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-4">
            <button
              onClick={scrollToContact}
              className="bg-primary text-white px-10 md:px-14 py-3 md:py-4 rounded-lg font-bold text-sm md:text-base hover:bg-primary-dark transition-all hover:shadow-lg flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer group"
            >
              無料相談を申し込む
              <i className="ri-arrow-right-line text-lg md:text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
        
        <div className="relative hidden lg:block">
          <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500">
            <img
              src="https://public.readdy.ai/ai/img_res/d5832b7f1af50bbd47436ede5f9f2fce.jpg"
              alt="スプレッドシート自動化イメージ"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
